import RequestPage from './BidPage'

export default RequestPage
